import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import axios from 'axios';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { global } from './global';
import { conSesionEnUrl } from './shared/utils/session-url.util';

@Injectable({
    providedIn: 'root',
})
export class ApiService {

    public url: string;
    public urlAI: string;
    private datosArray: any[] = [];

    constructor(private cookieService: CookieService, private http: HttpClient) {
        this.url=global.url;
        this.urlAI = '';
     }
    apiPostAI(endpoint: string, data: any){
    let licencia = this.cookieService.get('auth_token');
        var peticion = `${this.url}${endpoint}`;
        var mheaders = {
            'Content-Type': 'application/json',
            licencia: licencia,
        };

            const authToken = this.cookieService.get('auth_token'); // Obtén el token de las cookies
            if (authToken) {
                mheaders.licencia = authToken; // Asigna el token a tus encabezados
            }
        
        return axios.post(peticion, JSON.stringify(data), {
            headers: mheaders,
        });
}
    apiPost(endpoint: string, token: boolean, data: any, url: number) {
        let licencia = this.cookieService.get('auth_token');
        var peticion = `${this.url}${endpoint}${url === 1 ? '.php' : ''
            }`;
        var mheaders = {
            'Content-Type': 'application/json',
            licencia: licencia,
        };

        if (!!token) {
            const authToken = this.cookieService.get('auth_token'); // Obtén el token de las cookies
            if (authToken) {
                mheaders.licencia = authToken; // Asigna el token a tus encabezados
            }
        }

        return axios.post(peticion, JSON.stringify(data), {
            headers: mheaders,
        });
    }

    apiGet(endpoint: string, token: boolean, data: any, url: number) {

        var peticion = `${this.url}${endpoint}${data}${url === 1 ? '.php' : ''
            }`;
        var mheaders = {
            'Content-Type': 'application/json',
            licencia: '',
        };

        if (!!token) {
            const authToken = this.cookieService.get('auth_token'); // Obtén el token de las cookies
            if (authToken) {
                mheaders.licencia = authToken; // Asigna el token a tus encabezados
            }
        }
        console.log(mheaders);

        return axios.get(peticion, { 'headers': mheaders });
    }
    apiGet2(endpoint: string) {

        var peticion = `${this.url}${endpoint}`;
        var mheaders = {
            'Content-Type': 'application/json',
            licencia: '',
        };
        console.log(mheaders);

        return axios.get(peticion, { 'headers': mheaders });
    }
    
    apiGetIA(endpoint: string) {

        var peticion = `${this.urlAI}${endpoint}`;
        var mheaders = {
            'Content-Type': 'application/json',
            licencia: '',
        };

        return axios.get(peticion, { 'headers': mheaders });
    }

    apiGetCors(endpoint: string, token: boolean, data: any, php: number): Promise<any> {
        let url: string = `${this.url}${endpoint}${data}${php === 1 ? '.php' : ''}`;
        var eventSource = new EventSource(conSesionEnUrl(url, this.cookieService.get('session_id')));
        var c = 0;
        return new Promise((resolve, reject) => {
            try {
                if (eventSource.onerror == null) reject('0')
                eventSource.onmessage = function (event) {
                    var data = JSON.parse(event.data);
                    console.log(event);
                    resolve(data)
                    if (c == 0) {
                        c++;
                    } else {
                        data.forEach(function (item: any) {
                            console.log(item);
                        });
                    }             // Puedes agregar más celdas según tus necesidades
                };
            } catch (error) {
                reject(error)
            }

        });
    }

}
